import { Service } from '../Service';
export default class InstallerAccountService extends Service {
    constructor(axios) {
        super(axios);
    }
}
export { InstallerAccountService };
